import classnames from 'classnames';
import FixtureAlertHeader from '@components/atoms/fixture-alert-header';
import {
  getMatchStatus,
  MATCH_STATUS,
  OPTA_STATUSES,
} from '@stadionhq-v3/core';
import styles from './fixtureCardFirstSlot.module.scss';
import { FixtureCardFirstSlotProps } from './fixtureCardFirstSlot.types';

const FixtureCardFirstSlot = ({
  nativeProps,
  classNames,
  matchStatus,
  labels,
}: FixtureCardFirstSlotProps) => {
  const classes = classnames(
    [styles.tokens, styles.fixtureCardFirstSlot],
    classNames
  );

  // Do not render alert header for results
  if (
    getMatchStatus(matchStatus) === MATCH_STATUS.POST_MATCH ||
    matchStatus === OPTA_STATUSES.PRE_MATCH
  ) {
    return null;
  }

  return (
    <div
      {...nativeProps}
      className={classes}
      data-component="FixtureCardFirstSlot"
    >
      <FixtureAlertHeader matchStatus={matchStatus} labels={labels} />
    </div>
  );
};

export default FixtureCardFirstSlot;
